//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import StockConfigurationDepartmentSelector from './StockConfigurationDepartmentSelector.vue'
import { createFieldConfig } from '../../../../components/QSelectUtils.js'
import DateTimeField from '../../../../components/Field/DateTimeField.vue'
import ItemsSearchField from '../../../../components/Field/ItemsSearchField.vue'
import { formatDate } from '../../../../components/helpers.js'

export default {
  name: 'StockControlRecordGeneralInfo',
  components: {
    // StockConfigurationDepartmentSelector,
    DateTimeField,
    ItemsSearchField
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    vehicleIssuance: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      stockFieldConfig: createFieldConfig({ allRecordsFn: () => [] }),
      departmentFieldConfig: createFieldConfig({ allRecordsFn: () => [] }),
      controlEmployeeFieldConfig: createFieldConfig({ allRecordsFn: () => [] }),
      controlEmployeePositionFieldConfig: createFieldConfig({ allRecordsFn: () => [] }),
      vehicleIssuanceFieldConfig: createFieldConfig({ allRecordsFn: () => [] }),

      toolFieldConfig: createFieldConfig({ allRecordsFn: () => [] }),
      settingOperationOptions: [
        {
          key: 'add',
          name: 'Добавление контролируемой позиции'
        },
        {
          key: 'remove',
          name: 'Удаление контролируемой позиции'
        }
      ],
      zeroAmountOperationOptions: [
        {
          key: 'zeroAmountIn',
          name: 'Обнуление остатка'
        },
        {
          key: 'zeroAmountOut',
          name: 'Восстановление ненулевого остатка'
        }
      ],
      zeroAmountReasonOptions: [
        {
          key: 'debits',
          name: 'Перемещение/списание'
        },
        {
          key: 'initial',
          name: 'Контроль включен при нулевом остатке'
        }
      ],
      amountChangeSourceTypeOptions: [
        {
          key: 'onec',
          name: '1С'
        },
        {
          key: 'user',
          name: 'Пользователь'
        }
      ]

      // loading: false
    }
  },
  computed: {
    stockControlRecord: function () {
      return this.record || null
    }
  },
  methods: {
    formatDate: formatDate
  }
}

